import { createGlobalStyle } from "styled-components"
import media from "styled-media-query"

const LibCSS = createGlobalStyle`
   .pages-top {
      width: 100%;
      height: 254px;
      background-size: cover;
      h2 {
         width: 100%;
         height: 100%;
         padding-top: 135px;
         background-color: #FF3D0180;
         color: #fff;
         font-size: 4rem;
         text-align: center;
         ${media.lessThan("600px")`
            font-size: 3.2rem;
         `}
      }
   }
`
export default LibCSS